import TrustpilotHeader from './TrustpilotHeader'

export default TrustpilotHeader
